import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-como-protegemos-seus-dados',
  templateUrl: './como-protegemos-seus-dados.component.html',
  styleUrls: ['./como-protegemos-seus-dados.component.scss'],
})
export class ComoProtegemosSeusDadosComponent implements OnInit {
  constructor() {}
  infoboxes: Array<Object> = [
    {
      iconUrl: 'assets/icon-authenticate-2.svg',
      title: 'Nossos fornecedores e clientes protegem suas informações',
      description:
        'A Serasa Experian possui processos para garantir que seus fornecedores e clientes atendam os altos padrões de conformidade em relação a requisitos de proteção de dados. Estes processos garantem tanto uma boa escolha de fornecedores e clientes, bem como monitora continuamente o relacionamento comercial.',
    },
    {
      iconUrl: 'assets/icon-big-data-2.svg',
      title: 'Cumprindo as melhoras práticas de mercado',
      description:
        'Sempre buscamos cumprir as melhores práticas de mercado, sejam elas orientadas por leis, como Lei Geral de Proteção de Dados e Cadastro Positivo, autorregulações e/ou padrões internacionais como ISO 27.001.',
    },
    {
      iconUrl: 'assets/icon-clipboard.svg',
      title: 'Usamos apenas os dados mínimos necessários',
      description:
        'A Serasa Experian possui processos para garantir que sejam coletadas apenas a quantidade mínima de informações pessoais necessárias para fins de processamento. São adotadas medidas como, definir rigorosamente o formato dos dados recebidos, garantindo que apenas o necessário para processamento seja fornecido por nossos parceiros e aplicamos os mesmos critérios para os dados transferidos externamente para nossos clientes.',
    },
    {
      iconUrl: 'assets/icon-clock.svg',
      title: 'Mantemos seus dados apenas pelo tempo necessário',
      description:
        'Mantemos os seus dados em nossas bases enquanto for necessário para oferecer nossos serviços aos nossos clientes. Eventualmente será necessário manter seus dados para cumprimento de obrigações legais e resoluções de questionamentos. Entretanto, nossa necessidade de armazenar e usar suas informações pessoais será reavaliada frequentemente e qualquer informação que não seja mais necessária será descartada.',
    },
    {
      iconUrl: 'assets/icon-id-verification.svg',
      title: 'Nós protegemos seus dados e seus direitos constantemente',
      description:
        'A Serasa Experian possui processos para garantir a proteção dos seus direitos em todas as frentes de negócio. O impacto de qualquer uso de dados pessoais em nossos produtos é sempre avaliado antes de sua criação, assim, qualquer impacto negativo que você possa sofrer será identificado e eliminado. Adicionalmente a Serasa Experian executa frequentemente auditorias em seus produtos e serviços assegurando que os princípios de proteção e privacidade estão sendo respeitados e que os consumidores estão sendo tratados de maneira justa. Por último, todos os funcionários da Serasa Experian participam de treinamentos anuais relacionados à proteção de dados e segurança da informação.',
    },
    {
      iconUrl: 'assets/icon-computer.svg',
      title: 'Somos transparentes em relação aos seus dados e como os usamos',
      description:
        'O Portal de Proteção de dados pessoais possui informações que buscam fornecer transparência em assuntos como: o que fazemos com seus dados pessoais, de onde eles são captados e como você pode exercitar seus direitos. Este portal estará em constante atualização em harmonia com as expectativas do consumidor, do mercado e dos órgãos reguladores com a intenção de garantir de melhorar a transparência.',
    },
  ];
  ngOnInit(): void {}
}
